import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const SliderTiendaService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Slider_Tienda_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_slider_tienda: form.id_slider_tienda,
			titulo: form.titulo,
			subtitulo: form.subtitulo,
			imagen: form.imagen,
			url: form.url,
			imagen_archivo: form.imagen_archivo,
			imagen_formato: form.imagen_formato,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Slider_Tienda_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_slider_tienda: form.id_slider_tienda,
			titulo: form.titulo,
			subtitulo: form.subtitulo,
			imagen: form.imagen,
			url: form.url,
			imagen_archivo: form.imagen_archivo,
			imagen_formato: form.imagen_formato,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Slider_Tienda_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_slider_tienda) => {
		let params = {
			id_slider_tienda: id_slider_tienda
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Slider_Tienda_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
